import { render, staticRenderFns } from "./3D-Zam-City.vue?vue&type=template&id=d4895af2"
import script from "./3D-Zam-City.vue?vue&type=script&lang=js"
export * from "./3D-Zam-City.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports